import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { GetDoorEventDetail } from "../../../api/api";
import CustomTable from "../../../ui/custom-table";
import PeakHoursChart from "../../../Components/Graphs/HourlyVehicleChart";
import { TbClock } from "react-icons/tb";
import { FaRegUser } from "react-icons/fa";
import {
  MdOutlineCalendarMonth,
  MdOutlineLocationOn,
  MdWifiTethering,
} from "react-icons/md";
import { IoCameraOutline } from "react-icons/io5";
import DoorHourlyChart from "../../../Components/Graphs/DoorDetection";
import AccessTrendChart from "../../../Components/Graphs/DoorDetection";

const colors = ["#6a0dad", "#00a86b", "#ff8c00", "#1e90ff", "#ff1493"];
const formatHourlyDistribution = (hourlyObj) => {
  return Object.entries(hourlyObj || {}).map(([key, value]) => ({
    name: key,
    value,
  }));
};

function DoorDetectionDetail() {
  const navigate = useNavigate();
  const [eventData, setEventData] = useState([]);
  //console.log("eventData", eventData);
  const options = { day: "2-digit", month: "short", year: "numeric" };
  const [eventrecord, setEventRecord] = useState([]);
  //console.log("eventrecord", eventrecord);
  const [loading, setLoading] = useState(false);
  const today = new Date();
  //   const start_date = today.toISOString().split("T")[0]; // e.g., '2025-07-24'
  //   const end_date = start_date;
  const formattedDate = today.toLocaleDateString("en-GB", options);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [activeFilter, setActiveFilter] = useState("daily");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [customStart, setCustomStart] = useState("");
  const [customEnd, setCustomEnd] = useState("");
  const [showCustomFilter, setShowCustomFilter] = useState(false);

  const fetchEventData = async () => {
    setLoading(true);
    try {
      const page = pagination.pageIndex + 1;
      const limit = pagination.pageSize;
      const data = await GetDoorEventDetail(page, limit, startDate, endDate);
      //console.log("data", data);
      if (data?.data?.status === true) {
        setEventData(data?.data?.stats);
        setEventRecord(data?.data?.data);
      }
    } catch (error) {
      //console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEventData();
    updateDateRange("daily");
  }, []);

  const updateDateRange = (filter) => {
    const today = new Date();
    let start, end;

    switch (filter) {
      case "daily":
        start = end = today;
        break;
      case "weekly":
        start = new Date(today);
        start.setDate(today.getDate() - 7);
        end = today;
        break;
      case "monthly":
        start = new Date(today);
        start.setMonth(today.getMonth() - 1);
        end = today;
        break;
      default:
        start = end = today;
    }

    const format = (date) => date.toISOString().split("T")[0];
    setStartDate(format(start));
    setEndDate(format(end));
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "image_dataset_path",
        header: "Student Image",
        Cell: ({ row }) => {
          const imagePath = row.original.image_dataset_path;
          const imageUrl = imagePath
            ? `https://visionemptrack.greymatterz.com/${imagePath}`
            : "";

          return (
            imageUrl && (
              <img
                src={imageUrl}
                alt="Employee"
                style={{
                  width: "80px",
                  height: "80px",
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
              />
            )
          );
        },
      },

      { accessorKey: "door_opened_at", header: "Door open at" },
    ],
    []
  );

  useEffect(() => {
    if (startDate && endDate) {
      fetchEventData();
    }
  }, [startDate, endDate, pagination]);

  return (
    <div>
      <div>
        <div className="p-5 bg-white">
          <h3 className="mb-4">Secure Access Monitoring</h3>
          <div className="customerDwellTime">
            <div className="itemsBox">
              <span>
                <IoCameraOutline size={26} />
              </span>
              <div className="">
                <h5>Camera</h5>
                <h3>Cash Counter</h3>
              </div>
            </div>

            <div className="itemsBox">
              <span>
                <MdOutlineLocationOn size={26} />
              </span>
              <div className="">
                <h5>Location</h5>
                <h3>Cashier Area</h3>
              </div>
            </div>

            <div className="itemsBox">
              <span>
                <MdOutlineCalendarMonth size={26} />
              </span>
              <div className="">
                <h5>Tracking</h5>
                <h3>{formattedDate}</h3>
              </div>
            </div>

            <div className="itemsBox" style={{ marginLeft: "auto" }}>
              <button
                className="eventModeBtn"
                onClick={() => navigate("/door-log")}
                style={{
                  backgroundColor: "red",
                  color: "white",
                  fontWeight: "bold",
                  border: "none",
                  borderRadius: "8px",
                  padding: "8px 20px",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  cursor: "pointer",
                }}
              >
                <MdWifiTethering size={18} />
                Live
              </button>
            </div>
          </div>
        </div>
        <div className="p-5 border-top">
          <div className="d-flex">
            <h4 className="">Attendance Analyses</h4>
          </div>

          <div className="row">
            <div className="col-lg-6">
              <div className="customerAnalysesGrid">
                <div className="itemsBox">
                  <span>
                    <FaRegUser size={30} />
                  </span>
                  <div className="">
                    <h5>Failed Recognition</h5>
                    <div className="customer">
                      {eventData?.failed_recognitions}
                      <p>Students</p>
                    </div>
                  </div>
                </div>

                <div className="itemsBox">
                  <span>
                    <TbClock size={30} />
                  </span>
                  <div className="">
                    <h5>Most Frequent Employee</h5>
                    <div className="customer">
                      {eventData?.most_frequent_employee}
                      <p></p>
                    </div>
                  </div>
                </div>

                <div className="itemsBox">
                  <span>
                    <TbClock size={30} />
                  </span>
                  <div className="">
                    <h5>Successful Recognition</h5>
                    <div className="customer">
                      {eventData?.successful_recognitions}
                    </div>
                  </div>
                </div>

                <div className="itemsBox">
                  <span>
                    <TbClock size={30} />
                  </span>
                  <div className="">
                    <h5>Total Acess Attempt</h5>
                    <div className="customer">
                      {eventData?.total_access_attempts}
                      <p>Attempts</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="filter-toggle-wrapper d-flex justify-content-end mb-3 flex-wrap">
                <div className="filter-toggle-group">
                  <button
                    className={`filter-toggle-btn ${
                      activeFilter === "daily" ? "active" : ""
                    }`}
                    onClick={() => {
                      setActiveFilter("daily");
                      updateDateRange("daily");
                    }}
                  >
                    Daily
                  </button>
                  <button
                    className={`filter-toggle-btn ${
                      activeFilter === "weekly" ? "active" : ""
                    }`}
                    onClick={() => {
                      setActiveFilter("weekly");
                      updateDateRange("weekly");
                    }}
                  >
                    Weekly
                  </button>
                  <button
                    className={`filter-toggle-btn ${
                      activeFilter === "monthly" ? "active" : ""
                    }`}
                    onClick={() => {
                      setActiveFilter("monthly");
                      updateDateRange("monthly");
                    }}
                  >
                    Monthly
                  </button>
                  <button
                    className={`filter-toggle-btn ${
                      activeFilter === "custom" ? "active" : ""
                    }`}
                    onClick={() => {
                      setActiveFilter("custom");
                      updateDateRange("custom");
                      setShowCustomFilter(true);
                    }}
                  >
                    Custom
                  </button>
                </div>
                {activeFilter === "custom" && showCustomFilter && (
                  <div className="d-flex gap-3 align-items-center mb-3 flex-wrap custom-date-wrapper p-3 bg-light rounded">
                    <div>
                      <label className="form-label">Start Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={customStart}
                        onChange={(e) => setCustomStart(e.target.value)}
                      />
                    </div>
                    <div>
                      <label className="form-label">End Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={customEnd}
                        onChange={(e) => setCustomEnd(e.target.value)}
                      />
                    </div>
                    <div>
                      <button
                        className="btn btn-primary mt-4"
                        onClick={() => {
                          setStartDate(customStart);
                          setEndDate(customEnd);
                          setShowCustomFilter(false); // hide after apply
                        }}
                        disabled={!customStart || !customEnd}
                      >
                        Apply
                      </button>
                    </div>
                  </div>
                )}
              </div>
              <div className="graphBox p-4 bg-white shadow-sm rounded">
                <AccessTrendChart
                  data={formatHourlyDistribution(
                    eventData?.hourly_distribution
                  )}
                />
              </div>
            </div>
          </div>

          <div className="mt-5 cstTableCls">
            <CustomTable
              columns={columns}
              data={eventrecord}
              loading={loading}
              showsearch={true}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default DoorDetectionDetail;
